import type { BatchTransitionFormProps } from "./batch-transition-form.type";

import { Alert, Form } from "antd";

import { StateEditField } from "@/modules/state-edit-field";

import { useBatchTransitionForm } from "./batch-transition-form.hook";

const BatchTransitionForm = ({ state }: BatchTransitionFormProps) => {
  const { formProps, fieldProps, alert } = useBatchTransitionForm(state);

  return (
    <Form {...formProps}>
      <StateEditField {...fieldProps} />
      {alert && (
        <Alert {...alert} className="batch-transition-form-alert" showIcon />
      )}
    </Form>
  );
};

export default BatchTransitionForm;
